import { ScaleLinear } from 'd3-scale'
import { HorizontalTick } from './horizontalTick'
import React from 'react'
import './styles.scss'
interface Props {
  values: number[]
  x: ScaleLinear<number, number>
  y: ScaleLinear<number, number>
  format: (a: number) => string
  textAnchor: 'start' | 'end' | 'middle'
}

export const HorizontalTicks = ({ values, x, y, format,textAnchor }: Props) => {
  return (
    <>
      {values.map((m, i) => {
        return (
          <HorizontalTick
            key={i}
            x={x.range() as [number, number]}
            y={y(m)}
            val={format(m)}
            hideLabel={i === 0}
            textAnchor={textAnchor}
          />
        )
      })}
    </>
  )
}
